import { render } from "./NewsListItem.vue?vue&type=template&id=3705fa9f"
import script from "./NewsListItem.vue?vue&type=script&lang=js"
export * from "./NewsListItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/hapi/hapi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__